import React, { useMemo, useState } from "react";
import company from "assets/images/icon/company.png";
import companystatus from "assets/images/icon/company-status.png";
import onboard from "assets/images/icon/onboard.png";
import implementation from "assets/images/icon/implementation.png";
import Table from "../../components/Table";
import Button from "../../components/Button";
import PlusIcon from "assets/images/icon/plus-white.png";
import Input from "../../components/Input";
import search from "assets/images/icon/search-normal.png";
import ToggleSwitch from "../../components/ToggleSwitch";
import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import routes from "constants/routes";
import styles from "./benefits.module.scss";
import { cn, stringMerger } from "utils";
import CompanyLogo from "assets/images/icon/company-logo";
import UsersLogo from "assets/images/icon/users-logo";
import { getCompanyColumns, getEmployeeColumns } from "./columns";
import PersonIcon from "assets/images/icon/person-icon";
import PersonsIcon from "assets/images/icon/persons-icon";
import UserChecked from "assets/images/icon/user-checked";
import UserDisabled from "assets/images/icon/user-disabled";

const companyData = [];
const employeeData = [];

const companyCards = [
  { title: "Company Benefits", count: 0, icon: <PersonIcon /> },
  { title: "Employee Benefits", count: 0, icon: <PersonsIcon /> },
  { title: "Active Benefits", count: 0, icon: <UserChecked /> },
  { title: "Employee w/Benefits", count: 0, icon: <UserDisabled /> },
];

console.log("companycompany", typeof company);

function Benefits() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);

  function handleView(details) {
    navigate(`/contractor/view?code=${details.code}`);
  }

  const companyColumns = useMemo(() => {
    return getCompanyColumns();
  }, []);

  const employeeColumns = useMemo(() => {
    return getEmployeeColumns();
  }, []);

  return (
    <div className={cn("content", styles.benefitsContainer)}>
      <div className="start-new-payroll-section">
        <div style={{ padding: "16px 24px 16px 16px" }}>
          <div className="row mt-4">
            {companyCards?.map((item) => {
              return (
                <Card
                  title={item?.title}
                  count={item?.count}
                  icon={item?.icon}
                  isImage={false}
                />
              );
            })}
          </div>
        </div>
        <div className={styles.tabList}>
          <button
            className={cn(styles.tab, selectedTab === 0 ? styles.active : "")}
            onClick={() => setSelectedTab(0)}
          >
            <CompanyLogo color={selectedTab === 0 ? "#E7730A" : "#5F5F5F"} />
            <p>Company Benefits (Templates)</p>
          </button>
          <button
            className={cn(styles.tab, selectedTab === 1 ? styles.active : "")}
            onClick={() => setSelectedTab(1)}
          >
            <UsersLogo color={selectedTab === 1 ? "#E7730A" : "#5F5F5F"} />
            <p>Employee Benefits (Assigned)</p>
          </button>
        </div>
        <div className={cn("container-spacing")}>
          <div className="d-flex justify-content-between mt-4 mb-3">
            <div className="d-flex align-items-center gap-3">
              {selectedTab === 0 ? (
                <Button
                  startIcon={<img src={PlusIcon} />}
                  onClick={() =>
                    navigate(
                      stringMerger(
                        routes.BENEFITS.HOME,
                        routes.BENEFITS.ADD_EDIT_COMPANY_BENEFIT
                      )
                    )
                  }
                >
                  Add Company Benefit
                </Button>
              ) : (
                <Button
                  startIcon={<img src={PlusIcon} />}
                  onClick={() =>
                    navigate(
                      stringMerger(
                        routes.BENEFITS.HOME,
                        routes.BENEFITS.ADD_EDIT_EMPLOYEE_BENEFIT
                      )
                    )
                  }
                >
                  Add Benefit
                </Button>
              )}
              <ToggleSwitch />
            </div>
            <Input
              placeholder="Search by Name, Email, or Id"
              startIcon={search}
              style={{ width: "380px" }}
            />
          </div>
          <Table
            headers={selectedTab === 0 ? companyColumns : employeeColumns}
            data={selectedTab === 0 ? companyData : employeeData}
            handleView={handleView}
          />
        </div>
      </div>
    </div>
  );
}

export default Benefits;
